import { INotificationTableList } from "../../../slices/NotificationSlice";
import { INotificationFeatures, ISSOUser } from "../../../slices/UserSlice";
import {
  LEVEL_CONSTANT,
  STATUS_CONSTANT,
} from "../modal/CreateAndEditNotify/FormDataConstants";
import {
  ETableRowActionFieldApplicable,
  INotificationTableActions,
} from "./NotificationMangement";
const NotificationTableActionHandler = (
  notificationTableList: INotificationTableList[],
  user: ISSOUser | null,
  notificaionFeatures: INotificationFeatures
) => {
  if (!user) {
    notificationTableList.map((notifyData) => {
      notifyData.actions.edit.applicable = ETableRowActionFieldApplicable.Blur;
      notifyData.actions.assign.applicable =
        ETableRowActionFieldApplicable.Blur;
      notifyData.actions.delete.applicable =
        ETableRowActionFieldApplicable.Blur;
      notifyData.actions.view.applicable = ETableRowActionFieldApplicable.Blur;
      notifyData.actions.recall.applicable =
        ETableRowActionFieldApplicable.Blur;

      return notifyData;
    });
  }

  const actions: INotificationTableActions = {
    view: {
      applicable: ETableRowActionFieldApplicable.Hide,
      message: "",
    },
    edit: {
      applicable: ETableRowActionFieldApplicable.Hide,
      message: "",
    },
    delete: {
      applicable: ETableRowActionFieldApplicable.Hide,
      message: "",
    },
    assign: {
      applicable: ETableRowActionFieldApplicable.Hide,
      message: "",
    },
    recall: {
      applicable: ETableRowActionFieldApplicable.Hide,
      message: "",
    },
  };

  if (user) {
    notificationTableList.map((item) => {
      // View Action - always shown to the user
      item.actions.view.applicable = ETableRowActionFieldApplicable.Show;
      item.actions.view.message = "View Notification";

      // Edit Action - Status == Draft && who created
      if (
        item.status === STATUS_CONSTANT.draft &&
        user?.email === item.createdBy.name &&
        notificaionFeatures.editNotify
      ) {
        item.actions.edit.applicable = ETableRowActionFieldApplicable.Show;
        item.actions.edit.message = "Click to Edit";
      } else if (user.email !== item.createdBy.name) {
        item.actions.edit.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.edit.message =
          "This action could not be performed as it is restricted to the user who created it.";
      } else if (item.status !== STATUS_CONSTANT.draft) {
        item.actions.edit.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.edit.message =
          "The action could not be performed because the notification state was not met. (State: Draft)";
      }
      // Assign Action - Status == WAITING_SENT_FOR_PUBLICATION && Based on Level who can be Assign Admin or Manager
      if (
        item.status === STATUS_CONSTANT.waiting &&
        item.assignedUser.length === 0
      ) {
        // Check user roles for assignment
        if (
          item.level === LEVEL_CONSTANT.level1 &&
          notificaionFeatures.assignNotify.level1
        ) {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Show;
          item.actions.assign.message = "Click To Assign";
        } else if (
          item.level === LEVEL_CONSTANT.level2 &&
          notificaionFeatures.assignNotify.level2
        ) {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Show;
          actions.assign.message = "Click To Assign";
        } else {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Blur;
          item.actions.assign.message = `The action could not be performed because the user does not have access to this level of notification.`;
        }
      } else {
        item.actions.assign.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.assign.message =
          "The action could not be performed because the notification state was not met. (State: Waiting or Published)";
      }

      // Recall Action - Status == Published && same assigned user
      if (
        item.status === STATUS_CONSTANT.published &&
        item.assignedUser.toString() === user.email
      ) {
        const hasLevel1 = item.level === LEVEL_CONSTANT.level1;
        const hasLevel2 = item.level === LEVEL_CONSTANT.level2;
        if (
          (hasLevel1 && notificaionFeatures.recallNotify.level1) ||
          (hasLevel2 && notificaionFeatures.recallNotify.level2)
        ) {
          item.actions.recall.applicable = ETableRowActionFieldApplicable.Show;
          item.actions.recall.message = "Click To Recall";
        } else {
          item.actions.recall.applicable = ETableRowActionFieldApplicable.Blur;
          item.actions.recall.message =
            "The action could not be performed because the user does not have access to this level of notification.";
        }
      } else if (
        item.status === STATUS_CONSTANT.published &&
        item.publishStatus !== "PUBLISH_EFFECTIVE"
      ) {
        item.actions.recall.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.recall.message =
          "Notification Recall can't be performed, as the notification publishStatus is INEFFECTIVE";
      } else {
        item.actions.recall.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.recall.message =
          "The action could not be performed because the notification state was not met. (State : Published).";
      }
      // Delete Action - Status == Draft && who created
      if (
        item.status === STATUS_CONSTANT.draft &&
        user?.email === item.createdBy.name &&
        notificaionFeatures.deleteNotify
      ) {
        item.actions.delete.applicable = ETableRowActionFieldApplicable.Show;
        item.actions.delete.message = "Click to Delete";
      } else if (user.email !== item.createdBy.name) {
        item.actions.delete.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.delete.message =
          "This action could not be performed as it is restricted to the user who created it.";
      } else {
        item.actions.delete.applicable = ETableRowActionFieldApplicable.Blur;
        item.actions.delete.message =
          "The action could not be performed because the notification state was not met. (State: Draft).";
      }

      // Reassign Notification status should be waiting or publishd
      if (
        (item.status === STATUS_CONSTANT.waiting ||
          item.status === STATUS_CONSTANT.published) &&
        item.assignedUser.length > 0
      ) {
        let level = item.level;
        if (
          level === LEVEL_CONSTANT.level1 &&
          notificaionFeatures.assignNotify.level1
        ) {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Show;
          item.actions.assign.message = "Click to Reassign";
        } else if (
          level === LEVEL_CONSTANT.level2 &&
          notificaionFeatures.assignNotify.level2
        ) {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Show;
          item.actions.assign.message = "Click to Reassign";
        } else {
          item.actions.assign.applicable = ETableRowActionFieldApplicable.Blur;
          item.actions.assign.message = `The action could not be performed because the user does not have access to this level of notification.`;
        }
      }
      return item;
    });
  }
};
export default NotificationTableActionHandler;
